export const SET_TICKET = "SET_TICKET";
export const SET_TICKETS = "SET_TICKETS";
